import React from "react";
import { connect } from "react-redux";
import Drawer from 'devextreme-react/drawer';
import Toolbar, { Item } from "devextreme-react/toolbar";
import List from "devextreme-react/list";
import notify from 'devextreme/ui/notify';
import Form from "devextreme-react/form";
import ArrayStore from "devextreme/data/array_store";
import { ABECASUSER_LOGIN_TYPE } from "../../../common/permissions";
import TextArea from 'devextreme-react/text-area';
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import CommitTransactionsGridPreview from "../genaric-component/TransactionsGridPreview";
import CommitTransactionsPrintErrors from "../genaric-component/TransactionsPrintErrors";
import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Editing,
  Lookup,
} from "devextreme-react/data-grid";
import Accordion from 'devextreme-react/accordion';
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { LoadPanel } from 'devextreme-react/load-panel';

const searchpanel = [
  {
    ID: 1,
    Name: 'Search Filters'
  }
];
const list = React.createRef();
const dataGrid = React.createRef();
let ignoreListSelectionChange = false;
let ignoreMacroSelectionChange = false;
const selectBox = React.createRef();
const selectBoxMacro = React.createRef();
const orderByData = [
  { ID: 0, Text: "None" },
  { ID: 1, Text: "Ascending" },
  { ID: 2, Text: "Descending" },
];

const orderByDataSource = new ArrayStore({
  data: orderByData,
  key: "ID",
});

const prefixData = [
  { ID: 0, Text: "And" },
  { ID: 1, Text: "Or" },
];

const prefixDataSource = new ArrayStore({
  data: prefixData,
  key: "ID",
});
const groupData = [
  { ID: 0, Text: "No" },
  { ID: 1, Text: "Begin" },
  { ID: 2, Text: "End" },
];
const operationData = [
  { ID: 0, Text: "StartsWith" },
  { ID: 1, Text: "EndsWith" },
  { ID: 2, Text: "Contains" },
  { ID: 3, Text: "Equal" },
  { ID: 4, Text: "NotEqual" },
  { ID: 5, Text: "Greater" },
  { ID: 6, Text: "GreaterEqual" },
  { ID: 7, Text: "Less" },
  { ID: 8, Text: "LessEqual" },
  { ID: 9, Text: "Between" },
  { ID: 10, Text: "Includes" },
];

const groupDataSource = new ArrayStore({
  data: groupData,
  key: "ID",
});
const operationDataSource = new ArrayStore({
  data: operationData,
  key: "ID",
});

let accessToken = "";
class CommitTransaction extends React.Component {
  constructor(props) {
    super(props);
    accessToken = props.oidc.user.access_token;
    this.handleClosePreviewPopUpCallback = this.handleClosePreviewPopUpCallback.bind(this);
    this.handleClosePrintErrorsPopUpCallback = this.handleClosePrintErrorsPopUpCallback.bind(this);
    this.ComitButtonClicked = this.ComitButtonClicked.bind(this);
    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.printErrorsButtonClicked = this.printErrorsButtonClicked.bind(this);

    this.selectionChanged = this.selectionChanged.bind(this);
    this.loadOMCommitTransactionFields = this.loadOMCommitTransactionFields.bind(this);
    this.dataFieldSelectionChanged = this.dataFieldSelectionChanged.bind(this);
    this.dataFieldRender = this.dataFieldRender.bind(this);

    this.state = this.getInitialState(props);

    this.toolbarItems = [{
      widget: 'dxButton',
      location: 'right',
      options: {
        icon: 'menu',
        onClick: () => this.setState({ opened: !this.state.opened }),
      },
    }];
    this.loadOMCommitTransactionFields();
  }
  getInitialState(props) {
    return {
      animationDuration: 300,
      selectedItems: [],
      loadComitIndicatorVisible: false,
      isPreviewGridPopupVisible: false,
      isPrintPreviewPopupVisible: false,
      connection: null,
      ABErros: [],
      previewData: [],
      opened: (props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE),
      generatedFileName: "",
      report: {
        key: "",
        name: "",
        fullName: "",
        ignoreCompany: false,
        parameterList: [],
        queryParameters: [],
        whereInfoList: [],
        filterWhereInfoList: [
        ],
      },
      formData: {},
      formItems: [],
    };
  }

  ComitButtonClicked = async () => {
    this.setState({
      loadIndicatorVisible: true,
    });
    const response = await this.CommitOMTransactions();
    notify({
      message: response.message,
      width: 500,
    }, (response.success ? 'success' : 'error'), 5000);
    this.setState({
      loadIndicatorVisible: false,
    });
  }
  CommitOMTransactions = async () => {
    try {
      let filterWhereInfoList = { filterWhereInfoList: this.state.report.filterWhereInfoList };
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.CommitTransactions}`,
        JSON.stringify(filterWhereInfoList),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false,
      });
      notify({
        message: 'Commit Process Failed Due To Data Errors - Use Print Errors Button View Report',
        width: 450,
      }, 'error', 2000);
      console.error('Error Commiting OM transaction.', error);
      throw error;
    }
  };
  async previewButtonClicked() {
    this.setState({
      loadIndicatorVisible: true
    });
    const data = await this.PreviewData();
    this.setState({
      previewData: data,
      isPreviewGridPopupVisible: true,
      loadIndicatorVisible: false
    });
  }
  PreviewData = async () => {
    try {
      let filterWhereInfoList = { filterWhereInfoList: this.state.report.filterWhereInfoList, program: "OMWEBCOMIT" };
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.GetTransHeader}`,
        JSON.stringify(filterWhereInfoList),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error Getting Transaction Data:', error);
      throw error;
    }
  }
  resetButtonClicked() {
    this.setState(this.getInitialState(this.props), () => {
      this.loadOMCommitTransactionFields();
    });
  }
  printErrorsButtonClicked = async () => {
    this.setState({
      isPrintPreviewPopupVisible: true,
    });
    this.setState({
      loadIndicatorVisible: true
    });
    const data = await this.GetABErrorswData();
    this.setState({
      ABErros: data,
      isPrintPreviewPopupVisible: true,
      loadIndicatorVisible: false
    });
  }
  GetABErrorswData = async () => {
    try {
      const res = await axios.post(
        `${window._env_.REACT_APP_APIS}/${routes.OM.GetABErrorsHeaders}`,
        JSON.stringify("OMWEBCOMIT"),
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      return res.data; // Return the response data
    } catch (error) {
      this.setState({
        loadIndicatorVisible: false
      });
      console.error('Error when fetching ABErrorsHeaders data:', error);
      throw error; // Re-throw the error for handling in the component
    }
  };
  handleClosePreviewPopUpCallback() {
    this.setState({
      isPreviewGridPopupVisible: false,
    });
  };
  handleClosePrintErrorsPopUpCallback() {
    this.setState({
      isPrintPreviewPopupVisible: false,
    });
  };
  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({
      selectedItems: newItems
    });
  }
  dataFieldRender(e) {
    var dataSource = dataGrid.current.instance().getDataSource();
    if (dataSource != null && dataSource._items != null) {
      var found = dataSource._items.find(i => i.origin == e.itemData.origin);
      if (found != null && found != undefined) {
        if (!e.component.isItemSelected(e.itemIndex)) {
          ignoreListSelectionChange = true;
          e.component.selectItem(e.itemIndex);
          ignoreListSelectionChange = false;
        }
      }
    }
  }
  dataFieldSelectionChanged(e) {
    if (!ignoreListSelectionChange) {
      if (e.addedItems != null && e.addedItems.length === 1) {
        var dataSource = dataGrid.current.instance().getDataSource();
        dataSource
          .store()
          .insert(e.addedItems[0])
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }

      if (e.removedItems != null && e.removedItems.length === 1) {
        var dataSource = dataGrid.current.instance().getDataSource();
        dataSource
          .store()
          .remove(e.removedItems[0].displayLabel)
          .done(function (dataObj, key) {
            dataSource.reload();
          })
          .fail(function (error) {
            alert(error);
          });
      }
    }
  }
  loadOMCommitTransactionFields() {
    var that = this;
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.reports.GetReport}?reportName=${'OMCOMMITTRANSACTION'}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {

        for (
          var i = 0;
          res.data.filterWhereInfoList != null &&
          i < res.data.filterWhereInfoList.length;
          i++
        ) {
          switch (res.data.filterWhereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.filterWhereInfoList[i].items != null && j < res.data.filterWhereInfoList[i].items.length;
                j++
              ) {

                if (res.data.filterWhereInfoList[i].from == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].from = res.data.filterWhereInfoList[i].items[j].text;
                }

                if (res.data.filterWhereInfoList[i].to == res.data.filterWhereInfoList[i].items[j].value) {
                  res.data.filterWhereInfoList[i].to = res.data.filterWhereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        for (
          var i = 0;
          res.data.whereInfoList != null &&
          i < res.data.whereInfoList.length;
          i++
        ) {
          switch (res.data.whereInfoList[i].fieldType) {
            case 5: // Flag
              for (
                var j = 0;
                res.data.whereInfoList[i].items != null && j < res.data.whereInfoList[i].items.length;
                j++
              ) {

                if (res.data.whereInfoList[i].from == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].from = res.data.whereInfoList[i].items[j].text;
                }

                if (res.data.whereInfoList[i].to == res.data.whereInfoList[i].items[j].value) {
                  res.data.whereInfoList[i].to = res.data.whereInfoList[i].items[j].text;
                }
              }
              break;
            default:
          }
        }

        that.setState({
          report: res.data,
        });

        var formData = new Object();

        var formItems = [];

        for (
          var i = 0;
          that.state.report.parameterList != null &&
          i < that.state.report.parameterList.length;
          i++
        ) {
          formData[that.state.report.parameterList[i].name] =
            that.state.report.parameterList[i].value;
          var formItem = new Object();
          formItem.dataField = that.state.report.parameterList[i].name;
          formItem.label = new Object();
          formItem.label.text = that.state.report.parameterList[i].label;
          switch (that.state.report.parameterList[i].parameterType) {
            case 1: // Integer
            case 2: // Decimal
              formItem.editorType = "dxNumberBox";
              break;
            case 3: // Boolean
              formItem.editorType = "dxCheckBox";
              break;
            case 4: // DateTime
              formItem.editorType = "dxDateBox";
              break;
            case 5: // Flag
              formItem.editorType = "dxSelectBox";
              formItem.editorOptions = new Object();
              formItem.editorOptions.items = [];

              for (
                var j = 0;
                j < that.state.report.parameterList[i].items.length;
                j++
              ) {
                var selectBoxItem = new Object();
                selectBoxItem.Value =
                  that.state.report.parameterList[i].items[j].value;
                selectBoxItem.Text =
                  that.state.report.parameterList[i].items[j].text;
                formItem.editorOptions.items.push(selectBoxItem);
              }

              formItem.editorOptions.displayExpr = "Text";
              formItem.editorOptions.valueExpr = "Value";
              break;
            default:
              formItem.editorType = "dxTextBox";
          }

          formItems.push(formItem);
        }

        that.setState({
          formData: formData,
        });

        that.setState({
          formItems: formItems,
        });

        var dataFilterDataSource = new ArrayStore({
          data: that.state.report.filterWhereInfoList,
          key: "displayLabel",
        });

        dataGrid.current.instance().option("dataSource", dataFilterDataSource);


        ignoreListSelectionChange = true;
        for (var i = 0; res.data.whereInfoList != null && i < res.data.whereInfoList.length; i++) {
          for (var j = 0; res.data.filterWhereInfoList != null && j < res.data.filterWhereInfoList.length; j++) {
            if (res.data.whereInfoList[i].origin == res.data.filterWhereInfoList[j].origin) {
              if (!list.current.instance().isItemSelected(i)) {
                list.current.instance().selectItem(i);
              }
              break;
            }
          }
        }
        ignoreListSelectionChange = false;
      })
      .catch((err) => {
        console.log(err, "Error getting data");
      });
  }
  render() {
    return (
      <>
        <div>
          <div className="row ">
            <div className="col-md-12 main-page">
              <div id="accordion" >
                <Accordion
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={this.state.animationDuration}
                  selectedItems={this.state.selectedItems}
                  onSelectionChanged={this.selectionChanged}
                  itemTitleRender={() => (
                                  <Toolbar className="accordian-toolbar">
                                  <Item location="before">
                                    <div className="title">
                                      <h6
                                        style={{
                                          color: window._env_.Color2
                                        }}
                                      >
                                       Commit Transaction
                                      </h6>
                                    </div>
                                  </Item>
                  
                                  <Item location="after">
                                    <Button  className="accordianButton" text="Start" onClick={this.ComitButtonClicked} type="default" />
                                  </Item>
                                  <Item location="after">
                                    <Button className="accordianButton" onClick={this.previewButtonClicked} text="Preview" />
                                  </Item>
                                  <Item location="after">
                                    <Button className="accordianButton" onClick={this.resetButtonClicked} text="Reset" />
                                  </Item>
                                  <Item location="after">
                                    <Button className="accordianButton" onClick={this.printErrorsButtonClicked} text="Print Errors" />
                                  </Item>
                                </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                      <div className="row">
                        <div className="col-md-3">
                          <TextArea className="accordian-textarea-height" stylingMode='outlined' labelMode="static" label="Enter Comment" autoResizeEnabled={false} ></TextArea>
                        </div>
                    </div>
                  )}
                  id="accordion-container" className="accordion-height"
                />
              </div>
            </div>
          </div>
          <div style={{ minWidth: "900px" }}>
            <Form
              id="form"
              labelMode="static"
              labelLocation="left"
              formData={this.state.formData}
              items={this.state.formItems}
              colCount={5}
            />
          </div>
        </div>
        <div className="row">
          <div className={this.state.opened ? 'toolbar-holder' : 'toolbar-holder collapse-drawer '}>
            <Toolbar items={this.toolbarItems} />
          </div>
        </div>
        <div className="row bg-white">
          <div>
            <LoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              onHiding={(() => this.setState({ loadIndicatorVisible: false }))}
              visible={this.state.loadIndicatorVisible}
              showIndicator={true}
              shading={true}
              showPane={true}
              hideOnOutsideClick={false}
            />
            <Drawer
              opened={this.state.opened}
              openedStateMode={'shrink'}
              position={'left'}
              revealMode={'slide'}
              render={() =>
                <List
                  ref={list}
                  dataSource={this.state.report.whereInfoList}
                  pageLoadMode="scrollBottom"
                  style={{ backgroundColor: '#F6F7FB' }}
                  displayExpr="displayLabel"
                  searchEnabled={true}
                  searchExpr="displayLabel"
                  showSelectionControls={true}
                  selectionMode="multiple"
                  onSelectionChanged={this.dataFieldSelectionChanged}
                  onItemRendered={this.dataFieldRender}
                ></List>}
              closeOnOutsideClick={false}
              className={this.state.selectedItems.length>0? "ReportFilterPanelHeightAccordionOpen" : "GridHeightTabPanel-with-toolbar"}>
              <div>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                  id="gridContainer"
                  ref={dataGrid}
                  showBorders={true}
                  rowAlternationEnabled={true}
                  allowColumnReordering={true}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onEditorPreparing={this.editorPreparing}
                  onCellClick={this.CellClik}
                  className={this.state.selectedItems.length>0?(this.state.formItems.length>0?"WMReportGridHeightWithAccordianDouble":"WMRTGridStyle"):"WMReportGridStyle-AccordianClosed"}
                >
                  <Editing
                    mode="cell"
                    newRowPosition="last"
                    refreshMode="repaint"
                    allowUpdating={true}
                    useIcons={true}
                  />
                  <Column
                    dataField="displayLabel"
                    caption="Display Label"
                    allowEditing={false}
                  />
                  <Column dataField="orderBy" caption="Order By">
                    <Lookup
                      dataSource={orderByDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="prefix" caption="Prefix">
                    <Lookup
                      dataSource={prefixDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="group" caption="Group">
                    <Lookup
                      dataSource={groupDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="operation" caption="Operation">
                    <Lookup
                      dataSource={operationDataSource}
                      displayExpr="Text"
                      valueExpr="ID"
                    />
                  </Column>
                  <Column dataField="from" caption="From" />
                  <Column dataField="to" caption="To" />
                  <Column caption="" allowEditing={false} cellRender={this.searchPopupCellRender} />
                </DataGrid>
              </div>
            </Drawer>
          </div>
        </div>
        {this.state.isPreviewGridPopupVisible &&
          <Popup
            visible={this.state.isPreviewGridPopupVisible}
            onHiding={this.handleClosePreviewPopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={"Preview"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <ScrollView width="100%" height="100%">
              <CommitTransactionsGridPreview dataSource={this.state.previewData} />
            </ScrollView>
          </Popup>
        }
        {this.state.isPrintPreviewPopupVisible &&
          <Popup
            visible={this.state.isPrintPreviewPopupVisible}
            onHiding={this.handleClosePrintErrorsPopUpCallback}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={"Print Errors"}
            container=".dx-viewport"
            closeOnOutsideClick={true}
          >
            <ScrollView width="100%" height="100%">
              <CommitTransactionsPrintErrors dataSource={this.state.ABErros} reportname="ABR003" reportformat="Standard Abecas" />
            </ScrollView>
          </Popup>
        }
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(CommitTransaction);
